import React from "react";
import {
  Box
} from 'grommet'

function FadeInInductee(props) {
  const [isVisible, setVisible] = React.useState(true);
  const [isInitiated, setInitiated] = React.useState(0); // Is initialised
  const domRef = React.useRef();
  const animate = props?.animate ?? true;

  const checkInit = () => {
    return isInitiated
  }

  const triggerVisible = (visible) => {
    //  Use this function to only trigger once
    setVisible(visible)
    if (visible){
      setInitiated(1);
    }
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      //setVisible(entry.isIntersecting)
      triggerVisible(entry.isIntersecting);
    });
  },{threshold: 0.05});

  React.useEffect(() => {
    observer.observe(domRef.current);
    return () => { observer.disconnect() }
  }, []);

  const getVisibleClassName = () => {
      if (!animate){
        return `inductee ${props.className ? props.className : ''}`
      }
      if (isInitiated == 1){
        // Always show visible after initiated
        return `inductee fade-in-section delay-${props.delay} is-visible ${props.className ? props.className : ''}`
      } else {
        return `inductee fade-in-section delay-${props.delay} ${isVisible ? 'is-visible' : ''} ${props.className ? props.className : ''}`
      }
  }

  /*
   * Render extra contents from props.extra
   * should be an array of components
   */
  const renderExtra = () => {
    if (props.hasOwnProperty('extra') && Array.isArray(props.extra)){
      return props.extra.map( (item) => item )
    }
  }

  return (
    <Box
      //flex="grow"
      basis={props.calcBasis()}
      align="center"
      margin="1%"
      className={getVisibleClassName()}
      ref={domRef}
      background={props.background}
      onClick={() => {props.onClick()}}
      focusIndicator={false}
    >
      {renderExtra()}
      {props.children}
    </Box>
  );
}

export default FadeInInductee;
